import { render, staticRenderFns } from "./AllianceItem.vue?vue&type=template&id=5763a951&scoped=true"
import script from "./AllianceItem.vue?vue&type=script&lang=js"
export * from "./AllianceItem.vue?vue&type=script&lang=js"
import style0 from "./AllianceItem.vue?vue&type=style&index=0&id=5763a951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763a951",
  null
  
)

export default component.exports